import { Component, ElementRef, HostListener, Input, OnDestroy, ViewChild } from '@angular/core';

declare let $: any;

@Component({
    template: '',
    standalone: true
})
export abstract class BaseSectionComponent implements OnDestroy {
    @Input() slideConfig: any = { autoplay: false };

    protected activeSliderElement: any | null = null;

    @ViewChild('features', { static: false }) set sliderRef(element: ElementRef) {
        if (element?.nativeElement) {
            this.activeSliderElement = $(element.nativeElement);
            this.initSlick(this.activeSliderElement);
        }
    }

    @HostListener('window:resize', [])
    onWindowResize() {
        if (this.activeSliderElement) {
            this.initSlick(this.activeSliderElement);
        }
    }

    ngOnDestroy(): void {
        if (this.activeSliderElement && this.activeSliderElement.hasClass('slick-initialized')) {
            this.activeSliderElement.slick('unslick');
        }
    }

    initSlick(element: any): void {
        if (!element) {
            return;
        }

        if (window.innerWidth >= 1200) {
            if (element.hasClass('slick-initialized')) {
                element.slick('unslick');
            }

            return;
        }

        if (element && !element.hasClass('slick-initialized')) {
            element.slick(this.slideConfig);
        }
    }
}
